import API from './api';
import { getCalendarPeriod } from './api-utils';

export function getCalendarData() {
  const calendarPeriod = getCalendarPeriod();
  return calendarPeriod === 'Future'
    ? API.get('/api/stripe/calendar/v2')
    : API.get('/api/stripe/calendar/past-events');
};

export default {
  getRefetchedStripeData(firstCheck = false, force = false) {
    return API.post('/api/stripe/load-stripe-data', { firstCheck, force });
  },
  getCustomersData() {
    return API.get('/api/stripe/customers-table');
  },
  getPurchaseTimeData() {
    return API.get('/api/stripe/purchase-time-data');
  },
  getCalendarData,
  getCalendarDataOld() { // TODO -- eventually remove
    return API.get('/api/stripe/calendar');
  },
  getSimpleData() {
    return API.get('/api/users/me/simple');
  },
  getSamplePaymentLink() {
    return API.get('/api/users/me/sample-payment-link');
  },
  /* Metrics Data */
  getMetricsV2Data() {
    return API.get('/api/users/me/metrics/v2');
  },
  getHistoricalMetrics({ startDate, endDate, withDetails } = {
    startDate: null,
    endDate: null,
    withDetails: false,
  }) {
    // startDate and endDate should be in UNIX timestamp format
    return API.get('/api/users/me/metrics/historical-metrics', {
      params: { startDate, endDate, withDetails },
    });
  },
  getMetricsSettings() {
    return Promise.all([
      API.get('/api/users/me/metrics/settings'),
      API.get('/api/users/me/metrics/filters'),
    ]);
  },
  getEmailReports() {
    return API.get('/api/email-reports');
  },
  getProfileData() {
    return API.get('/api/users/me/profile-info');
  },
  getPaymentData() {
    return API.get('/auth/payment');
  },
  getUserData() {
    return API.get('/auth/me');
  },
  getSubscriptionData() {
    return API.get('/api/subscription-plans/me');
  },
  postRecomputedData(api_url, body) {
    return API.post(api_url, body);
  },
};
